import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import HomePage from "@/pages/HomePage";
import HomePagePL from "@/pages/HomePagePL";
import AboutPage from "@/pages/AboutPage";
import AboutPagePL from "@/pages/AboutPagePL";
import ServicesPage from "@/pages/ServicesPage";
import SprintPage from "@/pages/SprintPage";
import SprintPagePL from "@/pages/SprintPagePL";
import BrandFoundationPage from "@/pages/BrandFoundationPage";
import BrandFoundationPagePL from "@/pages/BrandFoundationPagePL";
import VisualIdentityPage from "@/pages/VisualIdentityPage";
import VisualIdentityPagePL from "@/pages/VisualIdentityPagePL";
import ConsultationPage from "@/pages/ConsultationPage";
import ConsultationPagePL from "@/pages/ConsultationPagePL";
import AiProductsPage from "@/pages/AiProductsPage";
import AiProductsPagePL from "@/pages/AiProductsPagePL";
import ContactPage from "@/pages/ContactPage";
import ContactPagePL from "@/pages/ContactPagePL";
import ServicesPagePL from "@/pages/ServicesPagePL";
import FAQPage from "@/pages/FAQPage";
import CaseStudiesPage from "@/pages/CaseStudiesPage";
import QuizPage from "@/pages/QuizPage";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";

function App() {
  return (
    <div className="min-h-screen bg-white">
      <BrowserRouter>
        <ScrollToTop />
        <Navigation />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/sprint" element={<SprintPage />} />
          <Route path="/audit" element={<SprintPage />} />
          <Route path="/brand-foundation" element={<BrandFoundationPage />} />
          <Route path="/visual-identity" element={<VisualIdentityPage />} />
          <Route path="/consultation" element={<ConsultationPage />} />
          <Route path="/ai-products" element={<AiProductsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/case-studies" element={<CaseStudiesPage />} />
          <Route path="/quiz" element={<QuizPage />} />
          {/* Polish routes */}
          <Route path="/pl" element={<HomePagePL />} />
          <Route path="/pl/about" element={<AboutPagePL />} />
          <Route path="/pl/sprint" element={<SprintPagePL />} />
          <Route path="/pl/brand-foundation" element={<BrandFoundationPagePL />} />
          <Route path="/pl/visual-identity" element={<VisualIdentityPagePL />} />
          <Route path="/pl/consultation" element={<ConsultationPagePL />} />
          <Route path="/pl/ai-products" element={<AiProductsPagePL />} />
          <Route path="/pl/services" element={<ServicesPagePL />} />
          <Route path="/pl/contact" element={<ContactPagePL />} />
        </Routes>
        <Footer />
        <Toaster position="bottom-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
